export default __webpack_public_path__ + "static/media/noun-container-ship-5297419.18784f71.svg";